/** روابط الفوتر والسوشيال من الموقع الرسمي https://aait.sa */

export const AAIT_HOME_URL = 'https://aait.sa/';

export const AAIT_PORTFOLIO_URL = 'https://aait.sa/%d8%a7%d8%b9%d9%85%d8%a7%d9%84%d9%86%d8%a7/';

export const footerImportantLinks = [
  { label: 'الرئيسية', href: 'https://aait.sa/' },
  { label: 'فريق العمل', href: 'https://aait.sa/%d9%81%d8%b1%d9%8a%d9%82-%d8%a7%d9%84%d8%b9%d9%85%d9%84/' },
  { label: 'الرصد الاعلامي', href: 'https://aait.sa/category/%d8%a7%d9%84%d8%b1%d8%b5%d8%af-%d8%a7%d9%84%d8%a7%d8%b9%d9%84%d8%a7%d9%85%d9%8a/' },
  { label: 'اعمالنا', href: 'https://aait.sa/%d8%a7%d8%b9%d9%85%d8%a7%d9%84%d9%86%d8%a7/' },
  { label: 'المدونة', href: 'https://aait.sa/blog/' },
  { label: 'شركائنا', href: 'https://aait.sa/%d8%b4%d8%b1%d9%83%d8%a7%d8%a6%d9%86%d8%a7/' },
  { label: 'تواصل معنا', href: 'https://aait.sa/%d8%aa%d9%88%d8%a7%d8%b5%d9%84-%d9%85%d8%b9%d9%86%d8%a7/' },
];

export const footerServiceLinks = [
  { label: 'شركة تصميم مواقع', href: 'https://aait.sa/%d8%b4%d8%b1%d9%83%d8%a9-%d8%aa%d8%b5%d9%85%d9%8a%d9%85-%d9%85%d9%88%d8%a7%d9%82%d8%b9/' },
  { label: 'تصميم متجر الكترونى', href: 'https://aait.sa/%d8%aa%d8%b5%d9%85%d9%8a%d9%85-%d9%85%d8%aa%d8%ac%d8%b1-%d8%a7%d9%84%d9%83%d8%aa%d8%b1%d9%88%d9%86%d9%8a/' },
  { label: 'تصميم تطبيقات الجوال', href: 'https://aait.sa/%d8%aa%d8%b5%d9%85%d9%8a%d9%85-%d8%aa%d8%b7%d8%a8%d9%8a%d9%82%d8%a7%d8%aa-%d8%a7%d9%84%d8%ac%d9%88%d8%a7%d9%84/' },
  { label: 'خدمة التسويق الكترونى', href: 'https://aait.sa/%d8%a7%d9%84%d8%aa%d8%b3%d9%88%d9%8a%d9%82-%d8%a7%d9%84%d8%a7%d9%84%d9%83%d8%aa%d8%b1%d9%88%d9%86%d9%8a/' },
  { label: 'تصميم موشن جرافيك', href: 'https://aait.sa/%d9%81%d9%8a%d8%af%d9%8a%d9%88-%d9%85%d9%88%d8%b4%d9%86-%d8%ac%d8%b1%d8%a7%d9%81%d9%8a%d9%83/' },
  { label: 'تصميم أنظمة ERP', href: 'https://aait.sa/%d8%a3%d9%86%d8%b8%d9%85%d8%a9-erp/' },
  { label: 'تصميم نظام اودو', href: 'https://aait.sa/%d9%86%d8%b8%d8%a7%d9%85-odoo/' },
  { label: 'عمل الهوية التجارية', href: 'https://aait.sa/%d8%a7%d9%84%d9%87%d9%88%d9%8a%d8%a9-%d8%a7%d9%84%d8%aa%d8%ac%d8%a7%d8%b1%d9%8a%d8%a9/' },
  { label: 'خدمة الكول سنتر', href: 'https://aait.sa/%d8%ae%d8%af%d9%85%d8%a9-%d8%a7%d9%84%d9%83%d9%88%d9%84-%d8%b3%d9%86%d8%aa%d8%b1/' },
  { label: 'امتلك تطبيق تواصل اجتماعي', href: 'https://aait.sa/%d8%a7%d9%88%d8%a7%d9%85%d8%b1-%d8%aa%d9%88%d9%83/' },
  { label: 'والمزيد..', href: 'https://aait.sa/%d8%ae%d8%af%d9%85%d8%a7%d8%aa%d9%86%d8%a7/' },
];

export const footerLegalLinks = [
  { label: 'سياسة الشركة', href: 'https://aait.sa/%d8%b3%d9%8a%d8%a7%d8%b3%d8%a9-%d8%a7%d9%84%d8%b4%d8%b1%d9%83%d8%a9/' },
  { label: 'الشروط والآحكام', href: 'https://aait.sa/%d8%a7%d9%84%d8%b4%d8%b1%d9%88%d8%b7-%d9%88%d8%a7%d9%84%d8%a2%d8%ad%d9%83%d8%a7%d9%85/' },
];

export const socialLinks = [
  { icon: 'ri-facebook-fill', href: 'https://www.facebook.com/aaitsa1/', label: 'Facebook' },
  { icon: 'ri-linkedin-fill', href: 'https://www.linkedin.com/company/aait/', label: 'LinkedIn' },
  { icon: 'ri-twitter-x-line', href: 'https://x.com/aaitsa12?s=11', label: 'X' },
  { icon: 'ri-instagram-line', href: 'https://www.instagram.com/aaitsa.1?igsh=MXhqNGY3bjFleW50bA%3D%3D&utm_source=qr', label: 'Instagram' },
  { icon: 'ri-youtube-fill', href: 'https://www.youtube.com/channel/UC9QC5Xjme73ZINQbn86QSKA', label: 'YouTube' },
  { icon: 'ri-snapchat-fill', href: 'https://snapchat.com/t/m8noAdVA', label: 'Snapchat' },
  { icon: 'ri-behance-fill', href: 'https://www.behance.net/aaitsa', label: 'Behance' },
  { icon: 'ri-tiktok-fill', href: 'https://www.tiktok.com/@aaitsa?_t=ZS-8vkD25FOevM&_r=1', label: 'TikTok' },
];
